import { DEFAULT_PRE_SERVICES } from '@root/src/types';

const preServicesDefaultValuesFactory = (
  fieldType: DEFAULT_PRE_SERVICES,
) => {
  switch (fieldType) {
    case DEFAULT_PRE_SERVICES.INSURANCE:
      return true;
    case DEFAULT_PRE_SERVICES.FILE_UPLOAD_MANDATORY:
      return null;
    default:
      return '';
  }
};

export default preServicesDefaultValuesFactory;

export const generatePreServicesDefaultValues = (
  preServicesProps,
) => preServicesProps
  .map(preServiceProp => ({
    [preServiceProp.name]: preServicesDefaultValuesFactory(
      preServiceProp.key,
    ),
  }))
  .reduce((a, b) => ({
    ...a,
    ...b,
  }), {});
